import $ from 'jquery';

import StateManager from './scuba/StateManager';
import LayoutManager from './scuba/LayoutManager';
import HorizontalLayout from './scuba/HorizontalLayout';
import MobileLayout from './scuba/MobileLayout';

import Cart from './components/Cart';

require('./scuba/Navigation');
require('./scuba/Content');
require('./scuba/ListForm');
require('./scuba/ListSnap');
require('./scuba/ListLazyLoading');
require('./scuba/Menu');

require('./components/Background');
require('./components/Ellipsis');
require('./components/Gallery');
require('./components/LoginForm');
require('./components/ProductsForm');
require('./components/Quantity');


$(document.body).on('layout:change', function(){
  Cart.refresh();
});

// gestionnaire de layout
LayoutManager.setLayouts([
    new HorizontalLayout(),
    new MobileLayout(),
]);

// initialisation
$(document).ready(function() {
    var $body = $(document.body);
    var $wrap = $('.js-scuba__wrap').first();
    var $head = $('.js-scuba__head').first();
    var $main = $('.js-scuba__main').first();
    if (!$wrap.length) {
        $wrap = $('<div class="js-scuba__wrap"></div>').prependTo($body);
        $head.appendTo($wrap);
        $main.appendTo($wrap);
    }

    // $(window).on(StateManager.CONTENT_READY, function(event, node) {

    // });

    $(document).on('click', 'a', function(event) {
        // récupération du lien
        var $link = $(event.currentTarget);

        if (!$link.is('.js-quantity') && !$link.closest('.js-quantity').length){

          // récupération des informations
          var href = $link.attr('href');
          var target = $link.attr('target');
          var dataTarget = $link.attr('data-target');
          // var dataHeight = $link.attr('data-height') ||  ( parseInt( $(window).height() * 0.9 ) ) ;
          // var dataWidth = $link.attr('data-width') || Math.min ( parseInt( ( $(window).width() * 0.9 ) ) , 768 ) ;
          var callback = $link.attr('data-callback') || null ;

          // ouverture d'une page
          if (target === '_blank') {
              // console.log('link:', '_blank');
              // on laisse passer le lien sans rien faire
          }

          // lien à gérer par un JS
          else if (href === '#') {
            if ( callback && ( callback != '' ) ) eval( callback ) ;
            event.preventDefault();
          }

          // liens de DGT NAV
          else if ( (dataTarget && (dataTarget !== 'cover')) || $link.closest('.js-scuba__nav').length ) {
              event.preventDefault();
              // console.log('link:', 'nav');
              $("body").removeClass('has-cart-open');

              // récupère le page url pour retrouver le contexte en self ou after
              var pageUrl = $link.closest('.js-scuba__head,.js-scuba__page').data('url');

              // montre qu'on charge le lien
              $link.addClass('is-loading');

              StateManager.pushState(href, dataTarget, pageUrl)
              .fin(function() {
                  // remet dans l'état normal
                  $link.removeClass('is-loading');
              });
          }

        }
    });

    $(document).on('click', '.js-display-billing', function(event) {
      $(event.currentTarget).parent().toggleClass("is-billing-visible");
      event.preventDefault();
    });

    StateManager.init()
      .then(function() {
        LayoutManager.start()
          .then(function(){
            $(document.body).removeClass("is-loading")
          });
      })
      .fail(function(/*reason*/) {
        // console.error(reason && reason.stack ? reason.stack : reason);
      });
});



// WEBPACK FOOTER //
// ./scripts/main.js